import { put, call } from 'redux-saga/effects';
import { showAlert } from 'actions/index';
import { ActionTypes } from 'constants/index';

export function* getAlerts(api, action) {
  const response = yield call(api.getAlerts, action.payload);

  const { status, data } = response;

  if (status === 200) {
    const { rows, pages, currentPage, count } = data;
    yield put({
      type: ActionTypes.GET_ALERTS_SUCCESS,
      payload: { rows, pages, currentPage, count },
    });
  } else {
    const { errors } = data;
    yield put({
      type: ActionTypes.GET_ALERTS_FAILURE,
    });
    if (status !== 500 && status !== 401) {
      yield put(showAlert(errors.message, { variant: 'danger', timeout: 9 }));
    }
  }
}

export function* getAllAlerts(api, action) {
  const response = yield call(api.getAllAlerts, action.payload);

  const { status, data } = response;

  if (status === 200) {
    const { rows, pages, currentPage } = data;
    yield put({
      type: ActionTypes.GET_ALL_ALERTS_SUCCESS,
      payload: { rows, pages, currentPage },
    });
  } else {
    const { errors } = data;
    yield put({
      type: ActionTypes.GET_ALL_ALERTS_FAILURE,
    });
    if (status !== 500 && status !== 401) {
      yield put(showAlert(errors.message, { variant: 'danger', timeout: 9 }));
    }
  }
}

export function* markAlertAsViewed(api, action) {
  const response = yield call(api.markAlertAsViewed, action.payload);
  const { status } = response;

  if (status === 200) {
    yield put({
      type: ActionTypes.MARK_ALERT_AS_VIEWED_SUCCESS,
    });
    yield put({ type: ActionTypes.GET_PENDING_COUNT });
  } else {
    yield put({
      type: ActionTypes.MARK_ALERT_AS_VIEWED_FAILURE,
    });
    if (status !== 500 && status !== 401) {
      const {
        data: { errors },
      } = response;

      yield put(showAlert(errors.message, { variant: 'danger', timeout: 9 }));
    }
  }
}

export function* getPendingCount(api, action) {
  const response = yield call(api.getPendingCount, action.payload);
  const { status, data } = response;

  if (status === 200) {
    const { count } = data;
    yield put({
      type: ActionTypes.GET_PENDING_COUNT_SUCCESS,
      payload: { count },
    });
  } else {
    yield put({
      type: ActionTypes.GET_PENDING_COUNT_FAILURE,
    });
    if (status !== 500 && status !== 401) {
      const { errors } = data;
      yield put(showAlert(errors.message, { variant: 'danger', timeout: 9 }));
    }
  }
}
